module.exports = __webpack_public_path__ + "img/contact-map.a97007d2.png";